import * as React from 'react'

export function useEventCapacity(initialCapacity: number | null | undefined) {
  const [enabled, setEnabled] = React.useState(initialCapacity != null)
  const [capacity, setCapacity] = React.useState(initialCapacity?.toString() ?? '')

  return { enabled, setEnabled, capacity, setCapacity, value: enabled ? capacity : '' }
}
